import { Suspense } from 'react';
import CustomSpinner from '../components/Common/CustomSpinner';

export const withSuspense = (
  Component: React.LazyExoticComponent<React.ComponentType>,
) => {
  return (
    <Suspense fallback={<CustomSpinner height="100%" />}>
      <Component />
    </Suspense>
  );
};
